<div class="logo">
    <a href="/" class="simple-text logo-mini">
        <div class="logo-img">
            <img src="../assets/img/logo_mini.png" style="border-radius: 10px;" />
        </div>
    </a>
    <a href="/" class="simple-text logo-normal">
        SANLAMALLIANZ
    </a>
</div>
<div class="sidebar-wrapper removeScrollChild">
    <!-- User -->
    <div class="user">
        <div class="photo">
            <img src="../assets/img/faces/face-0.jpg" />
        </div>
        <div class="info">
            <a data-toggle="collapse" href="#collapseExample" class="collapsed">
                <span>
                    {{ localUser.user.name }}
                    <b class="caret"></b>
                </span>
            </a>
            <div class="clearfix"></div>
            <div class="collapse" id="collapseExample">
                <ul class="nav">
                    <li>
                        <a class="normal_link" (click)="openProfileEditor(template)">
                            <span class="sidebar-mini">P</span>
                            <span class="sidebar-normal">Profile</span>
                        </a>
                    </li>
                    <li>
                        <a class="normal_link" (click)="logOut()">
                            <span class="sidebar-mini">LO</span>
                            <span class="sidebar-normal">Se deconnecter</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- End User -->
    <div *ngIf="isNotMobileMenu()">
        <form #searchForm="ngForm" (ngSubmit)="gotToSearch(searchForm.valid)" class="navbar-form navbar-left navbar-search-form" role="search">
            <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-search"></i></span>
                <input required name="search_term" [(ngModel)]="search_term" type="text" class="form-control" placeholder="Rechercher...">
            </div>
        </form>
        <!-- <ul class="nav nav-mobile-menu">
            <li class="dropdown">
                <a href="#notifications" class="dropdown-toggle btn-rotate" data-toggle="dropdown">
                    <i class="ti-bell"></i>
                    <span class="notification">5</span>
                    <p class="hidden-md hidden-lg">
                        Notifications
                        <b class="caret"></b>
                    </p>
                </a>
                <ul class="dropdown-menu">
                    <li><a href="#not1">Notification 1</a></li>
                    <li><a href="#not2">Notification 2</a></li>
                    <li><a href="#not3">Notification 3</a></li>
                    <li><a href="#not4">Notification 4</a></li>
                    <li><a href="#another">Another notification</a></li>
                </ul>
            </li>
            <li class="dropdown">
                <a href="#settings" class="dropdown-toggle btn-rotate" data-toggle="dropdown">
                    <i class="ti-settings"></i>
                    <p class="hidden-md hidden-lg">
                        Settings
                        <b class="caret"></b>
                    </p>
                </a>
                <ul class="dropdown-menu">
                    <li><a routerLink="/profile" href="#not1">Profile</a></li>
                    <li><a routerLink="/configuration/taxes" href="#not2">Taxes</a></li>
                    <li><a routerLink="/configuration/frais" href="#not3">Frais</a></li>
                </ul>
            </li>
        </ul> -->
    </div>
    <ul class="nav fixSelection">
        <li routerLinkActive="active" *ngFor="let menuitem of menuItems">
            <!--If is a single link-->
            <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'">
                <i class="{{menuitem.icontype}}"></i>
                <p>{{menuitem.title}}</p>
            </a>
            <!--If it have a submenu-->
            <a data-toggle="collapse" href="#{{menuitem.id}}" *ngIf="menuitem.type === 'sub'">
                <i class="{{menuitem.icontype}}"></i>
                <p>{{menuitem.title}}<b class="caret"></b></p>
            </a>
            <!--Display the submenu items-->
            <div id="{{menuitem.id}}" class="collapse" *ngIf="menuitem.type === 'sub'">
                <ul class="nav">
                    <li routerLinkActive="active" *ngFor="let childitem of menuitem.children">
                        <a [routerLink]="[menuitem.path, childitem.path]">
                            <span class="sidebar-mini">{{childitem.ab}}</span>
                            <span class="sidebar-normal">{{childitem.title}}</span>
                        </a>
                    </li>
                </ul>
            </div>
        </li>
    </ul>
</div>

<ng-template #template>
    <form #profileForm="ngForm" (ngSubmit)="updateProfile(profileForm.valid, confirmPassword)">
        <div class="modal-header">
            <h4 class="modal-title pull-left">
                <i class="fa fa-user"></i>
                Profile
            </h4>
            <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">

            <h3>Compte</h3>
            <hr>
            <div class="row form-inputs">
                <div class="col-md-4">
                    <label>Nom <span class="star">*</span></label>
                    <input class="form-control" placeholder="Nom" name="name" type="text" [(ngModel)]="localUser.user.name"  #name=ngModel required>
                    <small [hidden]="name.valid || (name.pristine && !profileForm.submitted)" class="text-danger">
                        Vous devez entrer votre nom complet.
                    </small>
                </div>
            </div>

            <div class="row form-inputs">
                <div class="col-md-4">
                    <label>Email <span class="star">*</span></label>
                    <input class="form-control" type="email" placeholder="Email" name="email" type="text" [(ngModel)]="localUser.user.email" #email=ngModel pattern="^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$" required>
                    <small [hidden]="email.valid || (email.pristine && !profileForm.submitted)" class="text-danger">
                        Vous devez entrer votre company email.
                    </small>
                </div>
            </div>

            <div class="row form-inputs">
                <div class="col-md-4">
                    <label>Mot de passe <span class="star">*</span></label>
                    <!-- <input class="form-control" type="password" name="password" placeholder="Mot de passe" [(ngModel)]="localUser.user.password" #password=ngModel validateEqual="confirmPassword" reverse="true"> -->
                    <input class="form-control" type="password" name="password" placeholder="Mot de passe" [(ngModel)]="localUser.user.password" #password=ngModel>
                    <!-- <small [hidden]="password.valid || (password.pristine && !profileForm.submitted)" class="text-danger">
                        Vous devez entre un mot de passe
                    </small> -->
                </div>

                <div class="col-md-4">
                    <label>Valider votre mot de passe <span class="star">*</span></label>
                    <input class="form-control" type="password" name="confirm_password" placeholder="Valider votre mot de passe" [(ngModel)]="password_validation" #confirmPassword=ngModel validateEqual="password" reverse="false">
                    <small [hidden]="confirmPassword.valid || (confirmPassword.pristine && !profileForm.submitted)" class="text-danger">
                        Les mots de passe ne sont pas identiques
                    </small>
                </div>
            </div>

            <h3>Option d'impression</h3>
            <hr>
            <div class="row form-inputs">
                <div class="col-md-4">
                    <input [(ngModel)]="localUser.user.print_with_header" type="checkbox" name="print_with_header">
                    <label>Imprimer avec un en-tête</label>
                </div>
                <div class="col-md-4">
                    <input [(ngModel)]="localUser.user.print_with_footer" type="checkbox" name="print_with_footer">
                    <label>Imprimer avec un pied de page</label>
                </div>
                <div class="col-md-4">
                    <input [(ngModel)]="localUser.user.print_zero_accounts" type="checkbox" name="print_zero_accounts">
                    <label>Imprimer les comptes à Zero solde</label>
                </div>
            </div>

        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-large btn-fill btn-primary">
                <i *ngIf="!create_update_button_loading" class="fa fa-save"></i>
                <i *ngIf="create_update_button_loading" class="fa fa-refresh fa-spin"></i>
                <label>Mettre à jour</label>
            </button>
            <button type="button" class="btn btn-large btn-fill btn-warning" (click)="modalRef.hide()">
                <i class="fa fa-times"></i>
                <label>Fermer</label>
            </button>
        </div>
    </form>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.component.html